export const CWE_NAMES: { [id: number]: string } = {
  324: "Use of a Key Past its Expiration Date",
  321: "Use of Hard-coded Cryptographic Key",
  259: "Use of Hard-coded Password",
  242: "Use of Inherently Dangerous Function",
  261: "Weak Encoding for Password",
  128: "Wrap-around Error",
  123: "Write-what-where Condition",
  523: "Unprotected Transport of Credentials",
  548: "Exposure of Information Through Directory Listing",
  644: "Improper Neutralization of HTTP Headers for Scripting Syntax",
  784: "Reliance on Cookies without Validation and Integrity Checking in a Security Decision",
  90: "Improper Neutralization of Special Elements used in an LDAP Query ('LDAP Injection')",
  310: "Cryptographic Issues",
  113: "Improper Neutralization of CRLF Sequences in HTTP Headers ('HTTP Response Splitting')",
  657: "Violation of Secure Design Principles",
  840: "Business Logic Errors",
  602: "Client-Side Enforcement of Server-Side Security",
  489: "Active Debug Code",
  215: "Insertion of Sensitive Information Into Debugging Code",
  620: "Unverified Password Change",
  843: "Access of Resource Using Incompatible Type ('Type Confusion')",
  824: "Access of Uninitialized Pointer",
  770: "Allocation of Resources Without Limits or Throttling",
  670: "Always-Incorrect Control Flow Implementation",
  294: "Authentication Bypass by Capture-replay",
  290: "Authentication Bypass by Spoofing",
  639: "Authorization Bypass Through User-Controlled Key",
  120: "Buffer Copy without Checking Size of Input ('Classic Buffer Overflow')",
  312: "Cleartext Storage of Sensitive Information",
  319: "Cleartext Transmission of Sensitive Information",
  362: "Concurrent Execution using Shared Resource with Improper Synchronization ('Race Condition')",
  352: "Cross-Site Request Forgery (CSRF)",
  502: "Deserialization of Untrusted Data",
  425: "Direct Request ('Forced Browsing')",
  369: "Divide By Zero",
  415: "Double Free",
  494: "Download of Code Without Integrity Check",
  834: "Excessive Iteration",
  668: "Exposure of Resource to Wrong Sphere",
  200: "Exposure of Sensitive Information to an Unauthorized Actor",
  610: "Externally Controlled Reference to a Resource in Another Sphere",
  552: "Files or Directories Accessible to External Parties",
  209: "Generation of Error Message Containing Sensitive Information",
  287: "Improper Authentication",
  295: "Improper Certificate Validation",
  273: "Improper Check for Dropped Privileges",
  754: "Improper Check for Unusual or Exceptional Conditions",
  913: "Improper Control of Dynamically-Managed Code Resources",
  94: "Improper Control of Generation of Code ('Code Injection')",
  116: "Improper Encoding or Escaping of Output",
  924: "Improper Enforcement of Message Integrity During Transmission in a Communication Channel",
  178: "Improper Handling of Case Sensitivity",
  755: "Improper Handling of Exceptional Conditions",
  665: "Improper Initialization",
  20: "Improper Input Validation",
  22: "Improper Limitation of a Pathname to a Restricted Directory ('Path Traversal')",
  59: "Improper Link Resolution Before File Access ('Link Following')",
  667: "Improper Locking",
  88: "Improper Neutralization of Argument Delimiters in a Command ('Argument Injection')",
  1236: "Improper Neutralization of Formula Elements in a CSV File",
  79: "Improper Neutralization of Input During Web Page Generation ('Cross-site Scripting')",
  74: "Improper Neutralization of Special Elements in Output Used by a Downstream Component ('Injection')",
  77: "Improper Neutralization of Special Elements used in a Command ('Command Injection')",
  917: "Improper Neutralization of Special Elements used in an Expression Language Statement ('Expression Language Injection')",
  78: "Improper Neutralization of Special Elements used in an OS Command ('OS Command Injection')",
  89: "Improper Neutralization of Special Elements used in an SQL Command ('SQL Injection')",
  281: "Improper Preservation of Permissions",
  269: "Improper Privilege Management",
  212: "Improper Removal of Sensitive Information Before Storage or Transfer",
  404: "Improper Resource Shutdown or Release",
  307: "Improper Restriction of Excessive Authentication Attempts",
  119: "Improper Restriction of Operations within the Bounds of a Memory Buffer",
  920: "Improper Restriction of Power Consumption",
  776: "Improper Restriction of Recursive Entity References in DTDs ('XML Entity Expansion')",
  1021: "Improper Restriction of Rendered UI Layers or Frames",
  611: "Improper Restriction of XML External Entity Reference",
  662: "Improper Synchronization",
  129: "Improper Validation of Array Index",
  354: "Improper Validation of Integrity Check Value",
  347: "Improper Verification of Cryptographic Signature",
  915: "Improperly Controlled Modification of Dynamically-Determined Object Attributes",
  326: "Inadequate Encryption Strength",
  838: "Inappropriate Encoding for Output Context",
  829: "Inclusion of Functionality from Untrusted Control Sphere",
  459: "Incomplete Cleanup",
  444: "Inconsistent Interpretation of HTTP Requests ('HTTP Request Smuggling')",
  863: "Incorrect Authorization",
  682: "Incorrect Calculation",
  131: "Incorrect Calculation of Buffer Size",
  697: "Incorrect Comparison",
  681: "Incorrect Conversion between Numeric Types",
  276: "Incorrect Default Permissions",
  732: "Incorrect Permission Assignment for Critical Resource",
  669: "Incorrect Resource Transfer Between Spheres",
  704: "Incorrect Type Conversion or Cast",
  335: "Incorrect Usage of Seeds in Pseudo-Random Number Generator (PRNG)",
  1188: "Insecure Default Initialization of Resource",
  922: "Insecure Storage of Sensitive Information",
  532: "Insertion of Sensitive Information into Log File",
  331: "Insufficient Entropy",
  613: "Insufficient Session Expiration",
  345: "Insufficient Verification of Data Authenticity",
  522: "Insufficiently Protected Credentials",
  190: "Integer Overflow or Wraparound",
  191: "Integer Underflow (Wrap or Wraparound)",
  436: "Interpretation Conflict",
  835: "Loop with Unreachable Exit Condition ('Infinite Loop')",
  306: "Missing Authentication for Critical Function",
  862: "Missing Authorization",
  311: "Missing Encryption of Sensitive Data",
  909: "Missing Initialization of Resource",
  401: "Missing Release of Memory after Effective Lifetime",
  772: "Missing Release of Resource after Effective Lifetime",
  476: "NULL Pointer Dereference",
  203: "Observable Differences in Behavior to Error Inputs",
  193: "Off-by-one Error",
  672: "Operation on a Resource after Expiration or Release",
  346: "Origin Validation Error",
  125: "Out-of-bounds Read",
  787: "Out-of-bounds Write",
  617: "Reachable Assertion",
  763: "Release of Invalid Pointer or Reference",
  565: "Reliance on Cookies without Validation and Integrity Checking",
  918: "Server-Side Request Forgery (SSRF)",
  384: "Session Fixation",
  367: "Time-of-check Time-of-use (TOCTOU) Race Condition",
  252: "Unchecked Return Value",
  674: "Uncontrolled Recursion",
  400: "Uncontrolled Resource Consumption",
  427: "Uncontrolled Search Path Element",
  428: "Unquoted Search Path or Element",
  434: "Unrestricted Upload of File with Dangerous Type",
  426: "Untrusted Search Path",
  601: "URL Redirection to Untrusted Site ('Open Redirect')",
  416: "Use After Free",
  327: "Use of a Broken or Risky Cryptographic Algorithm",
  338: "Use of Cryptographically Weak Pseudo-Random Number Generator (PRNG)",
  134: "Use of Externally-Controlled Format String",
  470: "Use of Externally-Controlled Input to Select Classes or Code ('Unsafe Reflection')",
  798: "Use of Hard-coded Credentials",
  706: "Use of Incorrectly-Resolved Name or Reference",
  330: "Use of Insufficiently Random Values",
  916: "Use of Password Hash With Insufficient Computational Effort",
  908: "Use of Uninitialized Resource",
  640: "Weak Password Recovery Mechanism for Forgotten Password",
  521: "Weak Password Requirements",
  91: "XML Injection (aka Blind XPath Injection)",
};
